// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.league-menu {
    padding-top: var(--space-x2-and-half);
    padding-left: var(--space);
    height: 130vh;
    width: calc(calc(100% /12) * 2);
    position: fixed;
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
}

.league-menu.hide-menu {
    display: none;
}

.league-menu__title{
    margin-bottom: var(--space-and-half);
}

.league-menu__title__text{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: var(--space-and-half);
    line-height: calc( var(--space-and-half) + var(--space-quarter) );
    color: var(--primary-very-dark-color);
}

.league-menu__field {
    display: flex;
    align-items: center;
    margin-bottom: var(--space-and-half);
    cursor: pointer;
    margin-right: var(--space);
    padding: var(--space-quarter) var(--space-half-quarter);
}

.league-menu__field:hover {
    background-color: var(--new-green-color);
    color: var(--white-color);
    border-radius: var(--space-quarter);
}

.league-menu__field:hover .league-menu__field__icon span:before {
    color: var(--white-color);
}

.league-menu__field:hover .league-menu__field__data__text {
    
    color: var(--white-color);
}

.league-menu__field__icon {
    font-size: var(--space-and-half);
    margin-right: var(--space-quarter);
    color: var(--basic-gray-color);
}

.league-menu__field__icon.selected-item {
    color: var(--new-green-color);
}

.league-menu__field__data__text.baloa-normal-medium {
    color: var(--primary-dark-color);
}
.league-menu__field__data__text.selected-item {
    color: var(--white-color);
    
}

.league-menu__field.selected-item {
    background-color: var(--new-green-color);
    border-radius: var(--space-quarter);
}

.league-menu__field .icon-ball{
    font-size: 28px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 5px;
    height: 100%;
    color: var(--white-color);
    display: flex;
    justify-content: center;
    align-items: center;
}

.league-menu__field img{
    width: 35px;
    height: 35px;
    border-radius: 50%;
}

.league-menu__page-item__data{
    margin-left: var(--space-half-quarter);
}
.league-menu__page-item__data-name.baloa-names{
    color: var(--primary-dark-color);
}
.league-menu__page-item__data-username.baloa-username{
    color: var(--basic-gray-color);
}

.MuiAvatar-root.league-menu__list-item__avatar{
    width: 44px;
    height: 44px;
}

.league-menu__list-item.icon-ball {
    font-size: 34px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 5px;
    height: 44px;
    color: var(--white-color);
}

.league-menu__photo {
    width: calc(var(--space-and-half) + var(--space-eighth) + calc(5px * 2));
    height: calc(var(--space-and-half) + var(--space-eighth) + calc(5px * 2));
    min-width: var(--space-x2);
    min-height: var(--space-x2);
    position: relative;
    border-radius: 50%;
    margin-right: var(--space);
    display: flex;
}


.league-menu__photo.icon-ball {
    font-size: 28px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 4px;
    height: 36px;
    color: var(--white-color);
    display: flex;
    align-items: center;
    justify-content: center;
}

.league-menu__field__icon.selected-item span:before {
    color: var(--white-color);
}

.league-menu__page-info {
    width: 90%;
}

.league-menu-component__page-selector {
    margin-right: 16px;
}

.league-menu-component__page-selector .MuiButtonBase-root.MuiListItem-root.MuiListItem-gutters.MuiListItem-button {
    border: 1px solid var(--new-gray-background-color);
    border-radius: var(--space-quarter);
    margin-bottom: var(--space-and-half);
}

.league-menu__page-info .MuiListItemText-root {
    margin: 0;
}

.league-menu__list-item__text-name .MuiTypography-body1 {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc(var(--space) + var(--space-eighth) + 1px);
    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    color: var(--primary-very-dark-color);
    margin-bottom: var(--space-quarter);
}

.league-menu__list-item__text-username .MuiTypography-body1 {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-regular);
    font-size: var(--space);
    line-height: calc(var(--space) + var(--space-eighth) + 1px);
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    color: var(--primary-dark-color);
}

.league-menu-component__page-selector span.icon-chevron-down {
    font-weight: var(--font-bold);    
}

.league-menu__icon-chevron {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 10%;
}

`, "",{"version":3,"sources":["webpack://./src/shared/components/league-menu/LeagueMenuComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,0BAA0B;IAC1B,aAAa;IACb,+BAA+B;IAC/B,eAAe;IACf,8BAA8B;IAC9B,kDAAkD;AACtD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,gCAAgC;IAChC,iEAAiE;IACjE,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,eAAe;IACf,0BAA0B;IAC1B,uDAAuD;AAC3D;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;AACpC;AACA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,wCAAwC;IACxC,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;AAC1C;AACA;IACI,gCAAgC;AACpC;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,wEAAwE;IACxE,yEAAyE;IACzE,0BAA0B;IAC1B,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,aAAa;AACjB;;;AAGA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kDAAkD;IAClD,mCAAmC;IACnC,oCAAoC;AACxC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,yDAAyD;IACzD,4EAA4E;IAC5E,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,qCAAqC;IACrC,mCAAmC;AACvC;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gCAAgC;IAChC,uBAAuB;IACvB,2DAA2D;IAC3D,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,UAAU;AACd","sourcesContent":[".league-menu {\n    padding-top: var(--space-x2-and-half);\n    padding-left: var(--space);\n    height: 130vh;\n    width: calc(calc(100% /12) * 2);\n    position: fixed;\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.league-menu.hide-menu {\n    display: none;\n}\n\n.league-menu__title{\n    margin-bottom: var(--space-and-half);\n}\n\n.league-menu__title__text{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: var(--space-and-half);\n    line-height: calc( var(--space-and-half) + var(--space-quarter) );\n    color: var(--primary-very-dark-color);\n}\n\n.league-menu__field {\n    display: flex;\n    align-items: center;\n    margin-bottom: var(--space-and-half);\n    cursor: pointer;\n    margin-right: var(--space);\n    padding: var(--space-quarter) var(--space-half-quarter);\n}\n\n.league-menu__field:hover {\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n    border-radius: var(--space-quarter);\n}\n\n.league-menu__field:hover .league-menu__field__icon span:before {\n    color: var(--white-color);\n}\n\n.league-menu__field:hover .league-menu__field__data__text {\n    \n    color: var(--white-color);\n}\n\n.league-menu__field__icon {\n    font-size: var(--space-and-half);\n    margin-right: var(--space-quarter);\n    color: var(--basic-gray-color);\n}\n\n.league-menu__field__icon.selected-item {\n    color: var(--new-green-color);\n}\n\n.league-menu__field__data__text.baloa-normal-medium {\n    color: var(--primary-dark-color);\n}\n.league-menu__field__data__text.selected-item {\n    color: var(--white-color);\n    \n}\n\n.league-menu__field.selected-item {\n    background-color: var(--new-green-color);\n    border-radius: var(--space-quarter);\n}\n\n.league-menu__field .icon-ball{\n    font-size: 28px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 5px;\n    height: 100%;\n    color: var(--white-color);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.league-menu__field img{\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n}\n\n.league-menu__page-item__data{\n    margin-left: var(--space-half-quarter);\n}\n.league-menu__page-item__data-name.baloa-names{\n    color: var(--primary-dark-color);\n}\n.league-menu__page-item__data-username.baloa-username{\n    color: var(--basic-gray-color);\n}\n\n.MuiAvatar-root.league-menu__list-item__avatar{\n    width: 44px;\n    height: 44px;\n}\n\n.league-menu__list-item.icon-ball {\n    font-size: 34px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 5px;\n    height: 44px;\n    color: var(--white-color);\n}\n\n.league-menu__photo {\n    width: calc(var(--space-and-half) + var(--space-eighth) + calc(5px * 2));\n    height: calc(var(--space-and-half) + var(--space-eighth) + calc(5px * 2));\n    min-width: var(--space-x2);\n    min-height: var(--space-x2);\n    position: relative;\n    border-radius: 50%;\n    margin-right: var(--space);\n    display: flex;\n}\n\n\n.league-menu__photo.icon-ball {\n    font-size: 28px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 4px;\n    height: 36px;\n    color: var(--white-color);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.league-menu__field__icon.selected-item span:before {\n    color: var(--white-color);\n}\n\n.league-menu__page-info {\n    width: 90%;\n}\n\n.league-menu-component__page-selector {\n    margin-right: 16px;\n}\n\n.league-menu-component__page-selector .MuiButtonBase-root.MuiListItem-root.MuiListItem-gutters.MuiListItem-button {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: var(--space-quarter);\n    margin-bottom: var(--space-and-half);\n}\n\n.league-menu__page-info .MuiListItemText-root {\n    margin: 0;\n}\n\n.league-menu__list-item__text-name .MuiTypography-body1 {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc(var(--space) + var(--space-eighth) + 1px);\n    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    color: var(--primary-very-dark-color);\n    margin-bottom: var(--space-quarter);\n}\n\n.league-menu__list-item__text-username .MuiTypography-body1 {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-regular);\n    font-size: var(--space);\n    line-height: calc(var(--space) + var(--space-eighth) + 1px);\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    color: var(--primary-dark-color);\n}\n\n.league-menu-component__page-selector span.icon-chevron-down {\n    font-weight: var(--font-bold);    \n}\n\n.league-menu__icon-chevron {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    width: 10%;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
